module.exports = "input {\n  border: none; }\n"